import { motion } from 'framer-motion';
import { ArrowRight, BadgeEuro, FileCheck2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { needOptions } from '../../lib/marketingContent';

const icons = [BadgeEuro, FileCheck2];

export const NeedSelectorSection = () => {
  const { isDark } = useTheme();
  const navigate = useNavigate();

  const handleNeedClick = (target) => {
    if (target === 'aid-quiz') {
      navigate('/quiz-aides');
      return;
    }

    if (target === 'tax-quiz') {
      navigate('/quiz-impots');
      return;
    }

    navigate('/login?next=/dashboard/abonnements');
  };

  return (
    <section
      id="needs"
      className={`py-20 md:py-24 ${isDark ? 'bg-[#0F0F1A]' : 'bg-[#F8F7F4]'}`}
      data-testid="need-selector-section"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-10">
          <p className="text-[#81d8d0] text-sm font-semibold mb-3">De quoi as-tu besoin ?</p>
          <h2 className={`text-3xl md:text-5xl font-semibold tracking-tight ${isDark ? 'text-white' : 'text-[#1d1d1f]'}`}>
            Commence par ce qui peut te faire gagner le plus.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {needOptions.map((option, index) => {
            const Icon = icons[index];
            return (
              <motion.button
                key={option.title}
                type="button"
                onClick={() => handleNeedClick(option.target)}
                className={`text-left rounded-2xl border p-6 transition-all duration-300 ${
                  isDark
                    ? 'bg-white/5 border-white/10 hover:border-[#81d8d0]/50 hover:bg-white/8'
                    : 'bg-white border-gray-200 hover:border-[#81d8d0]/60 hover:shadow-lg'
                }`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                data-testid={`need-card-${index + 1}`}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-5 ${
                  isDark ? 'bg-[#81d8d0]/15' : 'bg-[#81d8d0]/12'
                }`}>
                  <Icon size={22} className="text-[#81d8d0]" strokeWidth={1.7} />
                </div>
                <h3 className={`text-xl font-semibold mb-3 ${isDark ? 'text-white' : 'text-[#1d1d1f]'}`}>
                  {option.title}
                </h3>
                <p className={`text-sm leading-6 mb-5 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
                  {option.description}
                </p>
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#81d8d0]">
                  {option.action}
                  <ArrowRight size={15} />
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NeedSelectorSection;
